import { createRegisterableComponent } from '@news-mono/web-common'
import React from 'react'
import { AFLDraftHeader, AFLDraftHeaderProps } from './AFLDraftHeader'

export const AFLDraftHeaderRegistration = createRegisterableComponent(
    'tw-afl-draft-header',
    (props: AFLDraftHeaderProps) => <AFLDraftHeader {...props} />,
)
